module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/async/loaders/asyncloader.js!./loaders/async/loaders/syncloader.js!./loaders/async/a.js
 ** module id = 6
 ** module chunks = 0
 **/